import { faFire, faHome, faMessage, faPlus, faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { useLocation, useNavigate } from 'react-router';
import useNotification from '../Hook/notification';
import { displayPopin } from '../Hook/popins';
import useUser from '../Hook/user';

let prevY = 0;

function MenuMobile() {
  const navigate = useNavigate();
  const user = useUser();
  const notification = useNotification();
  const location = useLocation();

  // useEffect(() => {
  //   console.log("here")
  //   const listener = () => {
  //     console.log("here");
  //     document.getElementById("bottom-bar")?.classList.toggle("hidden", window.scrollY > 30 && window.scrollY > prevY);
  //     prevY = window.scrollY;
  //   }
  //   window.addEventListener("scroll", listener);
  //   return () => window.removeEventListener("scroll", listener);
  // }, []);

  return (
    <div className='lg:hidden'>
      {/* The feed panel behind this bar is the same surface, so a tone step alone
          leaves nothing between them. The bar casts its own shadow up onto the
          content instead, with a hairline to catch the edge. */}
      <div id="bottom-bar" data-testid="mobile-navigation" className='h-bottom-nav w-full fixed z-40 bg-panel shadow-nav left-0 bottom-0 flex [&>*]:flex-1 gap-x-[1px]'>
        <div data-testid="mobile-nav-home" onClick={() => {
          if(location.pathname === "/") window.scrollTo({top: 0, left: 0, behavior: "smooth"})
          else navigate("/")
        }} className={'h-full flex flex-col justify-center items-center text-messageplaceholder gap-1 ' +
          (location.pathname === "/" ? ' !text-primary' : '')
        }>
          <FontAwesomeIcon className='w-1/3 h-1/3' icon={faHome} />
          <div className='text-xs'><FormattedMessage id="menu__home" /></div>
        </div>
        <div data-testid="mobile-nav-members" onClick={() => {
          if(location.pathname === "/members") window.scrollTo({top: 0, left: 0, behavior: "smooth"})
            else navigate("/members")
        }} className={'h-full flex flex-col justify-center items-center text-messageplaceholder whitespace-nowrap gap-1 ' +
          (location.pathname === "/members" ? ' !text-primary' : '')
        }>
          <FontAwesomeIcon className='w-1/3 h-1/3' icon={faUsers} />
          <div className='text-xs'><FormattedMessage id="menu_desktop__members" /></div>
        </div>
        <div data-testid="mobile-nav-uploader" onClick={() => {
          if(user?.informations?.type === "guest") return displayPopin()("login", { errorMessage: "terminated_guest_freetour" })
          navigate("/uploader")
        }} className={'h-full flex flex-col justify-start pt-2 items-center text-messageplaceholder gap-1 ' +
          (location.pathname === "/uploader" ? ' !text-primary' : '')
        }>
          {/* Raised out of the bar, so posting reads as the primary action — and it
              takes the same fill as Apply, which means a tint in dark and a solid
              accent in light, where a pale tint on near-white chrome vanishes. */}
          <div className='h-post-button w-post-button -mt-post-button-lift flex justify-center items-center rounded-avatar bg-tint-apply-bg text-tint-apply-fg shadow-post'>
            <FontAwesomeIcon className='text-xl' icon={faPlus} />
          </div>
        </div>
        <div data-testid="mobile-nav-top" onClick={() => {          
          if(location.pathname === "/top") window.scrollTo({top: 0, left: 0, behavior: "smooth"})
          else navigate("/top")
        }} className={'h-full flex flex-col justify-center items-center text-messageplaceholder gap-1 ' +
          (location.pathname === "/top" ? ' !text-primary' : '')
        }>
          <FontAwesomeIcon className='w-1/3 h-1/3' icon={faFire} />
          <div className='text-xs'><FormattedMessage id="menu__top_and_progress" /></div>
        </div>
        <div data-testid="mobile-nav-chat" onClick={() => {
          if(location.pathname === "/chat") window.scrollTo({top: 0, left: 0, behavior: "smooth"})
          else navigate("/chat")
        }} className={'h-full flex flex-col justify-center relative items-center text-messageplaceholder gap-1 ' +
          (location.pathname === "/chat" ? ' !text-primary' : '')
        }>
          <FontAwesomeIcon className='w-1/3 h-1/3' icon={faMessage} />
          <div className='text-xs'><FormattedMessage id="menu__chat" /></div>
          {notification.chat_message > 0 && <div className='absolute bg-green text-white h-4 w-4 rounded-full flex items-center justify-center top-2 right-5 text-xs'>{notification.chat_message}</div>}
        </div>
      </div>
    </div>
  )
}

export default MenuMobile
